
import React, { useState, useEffect, useRef } from 'react';
import { Category } from '@/types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useMediaQuery } from '@/hooks/use-media-query';

interface CategoryCarouselProps {
  categories: Category[];
  selectedCategory: string | null;
  onSelectCategory: (categoryId: string | null) => void;
}

const CategoryCarousel: React.FC<CategoryCarouselProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  const isMobile = useIsMobile();
  const isTablet = useMediaQuery("(min-width: 768px)");
  const visibleItems = isTablet ? 5 : 3;

  return (
    <Carousel
      className="w-full"
      opts={{
        align: "center",
        containScroll: false,
      }}
    >
      <CarouselContent className="-ml-2 md:-ml-4">
        <CarouselItem 
          key="all" 
          className="pl-2 md:pl-4 basis-1/3 md:basis-1/5"
        >
          <Button
            onClick={() => onSelectCategory(null)}
            variant={selectedCategory === null ? "default" : "outline"}
            className={cn(
              "w-full h-12 transition-all duration-300",
              selectedCategory === null ? 
                "scale-105 font-semibold shadow-md" : 
                "scale-95 opacity-80"
            )}
          >
            Todos
          </Button>
        </CarouselItem>
        
        {categories.map((category) => (
          <CarouselItem 
            key={category.id} 
            className="pl-2 md:pl-4 basis-1/3 md:basis-1/5"
          >
            <Button
              onClick={() => onSelectCategory(category.id)}
              variant={selectedCategory === category.id ? "default" : "outline"}
              className={cn(
                "w-full h-12 transition-all duration-300",
                selectedCategory === category.id ? 
                  "scale-105 font-semibold shadow-md" : 
                  "scale-95 opacity-80"
              )}
            >
              {category.name}
            </Button>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="hidden md:flex">
        <CarouselPrevious 
          className="absolute left-1 -translate-y-1/2 top-1/2"
          variant="ghost" 
        />
        <CarouselNext 
          className="absolute right-1 -translate-y-1/2 top-1/2"
          variant="ghost" 
        />
      </div>
    </Carousel>
  );
};

export default CategoryCarousel;
